
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    /* ⚠ `updateViaCache: 'none'` (25/08/2026, Juan: "continua igual a
       antes"). Sem isto o navegador pode servir o próprio `sw.js` do
       cache HTTP — e um service worker velho mantém todo o resto velho,
       porque é ele quem decide o que servir.

       E `controllerchange` recarrega UMA vez quando um sw novo assume:
       sem isso a aba aberta continua com o código antigo até ser
       fechada, que é o que fazia parecer que o deploy não pegou. */
    let recarregando = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (recarregando) return;
      recarregando = true;
      window.location.reload();
    });
    navigator.serviceWorker.register('/sw.js', { updateViaCache: 'none' })
      .catch(e => console.error('[carga]', e.message));

    /* ⚠ SEM ISTO O ANDROID PODE APAGAR O TRABALHO DE QUEM CONFERE
       (31/08/2026, auditoria do offline a pedido do Juan: "a prioridade
       seria o offline estar 100%").

       Cache e IndexedDB são, por padrão, armazenamento DESCARTÁVEL: com
       o celular cheio, o sistema limpa sem avisar e sem pedir nada. Na
       Sala 1 isso significa perder a conferência inteira — o rascunho, a
       fila de envio e as fotos em base64 vivem exatamente aí, e o
       conferente trabalha justamente onde não há sinal para subir na
       hora.

       `persist()` pede ao navegador que trate estes dados como
       permanentes. Em app instalado o Android costuma conceder sem
       perguntar nada ao usuário.

       ⚠ NÃO É GARANTIA, e por isso o resultado é registrado: o navegador
       pode recusar, e quando recusa é bom saber pelo log em vez de
       descobrir por uma conferência perdida. Também não protege de quem
       limpa os dados do app à mão — nada protege disso.

       Roda depois do registro do worker de propósito: é o worker que
       cria as stores, e pedir persistência antes delas existirem mede o
       que ainda não há. */
    navigator.storage?.persist?.()
      .then(ok => {
        if (!ok) console.warn('[armazenamento] o navegador NÃO garantiu persistência — dados offline podem ser apagados com o aparelho cheio');
      })
      .catch(e => console.warn('[armazenamento]', e.message));
  });
}

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { instalarVoltarDosModais } from './hooks/useVoltarNavegador';
import { ligarErrosDaTela } from './utils/erroDaTela.js';
ligarErrosDaTela();   // (V1892) o erro solto da tela vai para a Administração Geral → Servidor → O sistema
/* o voltar do celular fecha o modal de cima, em todas as salas (26/09/2026) */
instalarVoltarDosModais();

/* O carimbo de build saiu daqui (26/08/2026, pedido do Juan: "só para o
   master"). Ele precisa do `isMaster` do AuthContext, e aqui fora do
   `AuthProvider` o contexto não existe — montado neste ponto, ele
   apareceria para todo mundo ou não apareceria para ninguém.

   Agora vive no fim do `App.jsx`, dentro do provider. */
import { iniciarCamadas } from './utils/camadas';   // (V1907) o voltar, o Esc, a trava da página e a alça de toda camada
iniciarCamadas();
import { iniciarDicas } from './utils/dica';   // (V1932.6) o balão de informação: todo title vira o balão da carcaça (nada nativo)
iniciarDicas();
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);
